import { render, staticRenderFns } from "./AddReferral.vue?vue&type=template&id=386b2322&scoped=true&"
import script from "./AddReferral.vue?vue&type=script&lang=js&"
export * from "./AddReferral.vue?vue&type=script&lang=js&"
import style0 from "./AddReferral.vue?vue&type=style&index=0&id=386b2322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b2322",
  null
  
)

export default component.exports